import { NgModule } from '@angular/core';
import { BlinkDirective } from './blink'


@NgModule({
  declarations: [BlinkDirective],
  exports: [BlinkDirective]
})
export class DirectivesModule{}
